// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
// import VueI18n from 'vue-i18n'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont2/iconfont.css";
import "@/assets/scss/common.scss";
import "@/assets/scss/flex.scss";
import "flex.css";
// import '../theme/index.css'
import { api } from "./service/api";
import apiList from "@/service/apiList";
import * as filters from "./utils/filter"; // global filters
// import './components/common//toast'
// import Toast from './components/common/alert/index'
import "./permission";
export const EventBus = new Vue();
Vue.config.productionTip = false;
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});
// Vue.use(Toast)
// Vue.use(VueI18n)
Vue.use(ElementUI);
Vue.prototype.$api = api;
Vue.prototype.$apiList = apiList;
Vue.prototype.router = router;
// import Vue from 'vue'
// router.beforeEach((to, from, next) => {
//   if (to.path === '/') {
//     localStorage.clear()
//   }
//   let token = localStorage.getItem('token')
//   let jzbEnable = localStorage.getItem('jzb_enable')
//   if (!token && to.path !== '/') {
//     next({ path: '/' })
//   } else {
//     if (jzbEnable === '0') {
//       if (to.path.indexOf('user') !== -1) {
//         console.log(to.path, 'to.path')
//         next({ path: '/order/manage' })
//       } else {
//         next()
//       }
//     } else {
//       next()
//     }
//   }
// })
// const i18n = new VueI18n({
//   locale: localStorage.getItem('locale') || 'zh', // 语言标识
//   messages: {
//     'zh': require('../static/common/lang/zh'),
//     'en': require('../static/common/lang/en')
//   }
// })
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js